import React from 'react';

/**
 * WednesdayChip — marks a weekend figure that also counts the film's
 * Wednesday previews (a first screening on the Wednesday before the weekend's
 * Thursday). Sits on the line under a film's name, never beside it, so it
 * cannot squeeze the name on a phone.
 */
function WednesdayChip({ tickets }) {
  return (
    <span
      title={tickets ? `רביעי: ${tickets.toLocaleString()} כרטיסים` : undefined}
      style={{
        display: 'inline-block', flexShrink: 0, whiteSpace: 'nowrap',
        fontSize: 10, fontWeight: 700, lineHeight: 1.5,
        color: 'var(--presale)', background: 'var(--presale-bg)',
        padding: '0 6px', borderRadius: 5,
      }}
    >כולל רביעי</span>
  );
}

export default WednesdayChip;
